<template>
  <div class="text-sm">
    <p class="mt-6">
      <b>2024.11.29</b> - Shop "Sell All" button, grouped starting Caverns runs, moving
      bags with items in them, AI & bug fixes, and a little balance just for good measure
      :)
    </p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>Caverns: heroes now start each run grouped together</li>
      <li>
        Reduced number of particles rendered for Blessed condition and Molotov explosion
      </li>
      <li>
        Boosted Suture bleed reduction potency: (20 + Level*(Le/8 + De/12)) --> (20 +
        Level*(Le/4 + De/8))
      </li>
      <li>Resizing the window from the Inn screen no longer breaks the universe</li>
      <li>Added a "Sell All" button to the shop</li>
      <li>Player names can now have characters from any language</li>
      <li>You can now move around bags with items in them.</li>
      <li>Fixed a bug calculating teams' HP remaining bars in the Inn/Arena</li>
      <li>Fixed a bug unlocking bag slots from the Shop</li>
      <li>Fixed AI lockups caused by Enraged conditions</li>
      <li>
        Fixed AI bugs preventing the Support tree from using Send Mana and Sanctuary
      </li>
      <li>Increased Sanctuary effect range from 2 -> 3</li>
      <li>And many other bug fixes!</li>
    </ul>
  </div>
</template>
